// client/src/pages/BlogDetail.js
import React from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import blogs from "../data/blogs";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

export default function BlogDetail() {
  const { slug } = useParams();
  const post = blogs.find((b) => b.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16 flex items-center justify-center">
        <div className="text-center space-y-4">
          <p className="text-lg font-semibold">Blog post not found.</p>
          <Link
            to="/blogs"
            className="px-5 py-2 rounded-xl bg-purple-600 hover:bg-purple-700 text-sm font-semibold"
          >
            Back to blogs
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        {...fadeUp(0.05)}
        className="max-w-4xl mx-auto text-center mb-10"
      >
        <Link to="/" className="inline-flex items-center justify-center gap-3">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold tracking-wide">SMSOrbit</span>
        </Link>
        <p className="mt-4 text-xs uppercase tracking-wide text-purple-300">
          {post.category}
        </p>
        <h1 className="mt-2 text-3xl md:text-4xl font-bold">{post.title}</h1>
      </motion.div>

      <motion.div
        {...fadeUp(0.1)}
        className="max-w-4xl mx-auto rounded-3xl bg-[#090912] border border-white/5 p-8 md:p-10 text-sm md:text-base text-gray-200 space-y-4 leading-relaxed"
      >
        {post.content.map((para, idx) => (
          <p key={idx}>{para}</p>
        ))}

        <div className="pt-4">
          <Link
            to="/blogs"
            className="inline-flex items-center px-4 py-2 rounded-xl bg-purple-600 hover:bg-purple-700 text-sm font-semibold"
          >
            ← Back to SMSOrbit Blogs
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
